{
  "checkIn": {
    "confirmation": {
      "pdf_v2": {
        "buttonText": "Lataa (v2)"
      }
    }
  },
  "subHeader": {
    "backToMyBookings": "Poistu sivulta",
    "backToMyBookingsAria": "Poistu sivulta"
  },
  "reviewPage": {
    "backButtonTravelExtras": "Lisäpalvelut"
  },
  "disruption": {
    "notices": {
      "tripChanged": {
        "title": "Matkasi kohteeseen {city} on muuttunut."
      }
    },
    "flight": {
      "newFlight": "Uusi lento",
      "unchanged": "Ei muutoksia",
      "previously": "Aiemmin"
    },
    "connection": {
      "transferTime": "Vaihtoaika"
    },
    "steps": {
      "continueToReturn": "Jatka paluulentoon",
      "continueToReview": "Jatka yhteenvetoon",
      "confirm": "Vahvista uudet lennot",
      "checkOtherOptions": "Katso muut vaihtoehdot",
      "cancelFlights": "Peru lennot",
      "departureTitle": "Uusi menolento",
      "returnTitle": "Uusi paluulento",
      "reviewTitle": "Tarkista ja vahvista uusi matkasuunnitelmasi",
      "asBooked": "Varauksen mukaan",
      "back": "Takaisin"
    }
  }
}
